import React, { useRef, useState } from "react";
import { faPause, faPlay } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useWavesurfer } from "@wavesurfer/react";
import { Colors } from "../Constants";

const AudioPlayer = ({ file }) => {
  const containerRef = useRef(null);

  // const [duration, setDuration] = useState("0:00");

  const { wavesurfer, isReady, isPlaying, currentTime } = useWavesurfer({
    barWidth: 2,
    barGap: 6,
    cursorWidth: 0,
    container: containerRef,
    url: file,
    waveColor: "#fff",
    progressColor: Colors.primary, // "rgb(255, 83, 73,0.5)"
    height: 40,
  });

  const updatePlaying = () => {
    wavesurfer && wavesurfer.playPause();
  };

  return (
    <div className="audio-player-wrapper">
      <span className="play-icon" onClick={updatePlaying}>
        <FontAwesomeIcon icon={!isPlaying ? faPlay : faPause} color="#fff" />
      </span>

      <div className="audio-content">
        <div ref={containerRef} />

        <div className="audio-time">01:30</div>
      </div>
    </div>
  );
};

export default AudioPlayer;
